import React, {useCallback, useEffect, useState} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import {useDocumentViewer} from '../../context/DocumentViewerContext';
import styles from './styles/answer-box.module.css';

import ViewButtonBox from './ViewButtonBox';
import ChartBox from '../chart/ChartBox';
import Table from '../data/Table';
import Loading from '../common/Loading';

import {Box, Button} from '@mui/material';
import WbTwilightOutlined from '@mui/icons-material/WbTwilightOutlined';

const AnswerBox = ({ isStreaming, isWaitingData, streamingChatId, chat, botList, currentBotType, updateViewType, handleChangeCurrentBot, handleChangeMessage, handleSendMessage }) => {
    const [pending, setPending] = useState(null); // 이상탐지 버튼 클릭 후 봇 상태 변경 대기

    const { answerId, question, answer, data, referenceList, viewType, botType } = chat;

    const { openRightSideBar } = useDocumentViewer();

    // 오른쪽 사이드바를 열어 문서 뷰어를 렌더링하는 함수
    const openDocumentViewer = useCallback((documentList, index) => { // 함수가 한 번만 생성되고 재사용할 수 있도록 최상위에 정의하고 useCallback 사용
        openRightSideBar(documentList, index);
    }, [openRightSideBar]);

    // 이상탐지 버튼 클릭 시 ABNORMAL 봇으로 교체하는 함수
    const changeBotToAbnormal = () => {
        // botList에서 type이 ABNORMAL인 봇 찾기
        const abnormalBot = botList?.find(bot => (bot.type || '').toUpperCase() === 'ABNORMAL');

        if (!abnormalBot) return;
        
        const { id, type } = abnormalBot;
        setPending(question);                 // 보내야 할 질문 저장
        handleChangeCurrentBot({ id, type }); // 봇 교체
    };

     // 봇이 ABNORMAL로 바뀌면 질문 전송
    useEffect(() => {
        if (!pending) return;

        if ((currentBotType || '').toUpperCase() === 'ABNORMAL') {
            handleChangeMessage({ target: { name: 'message', value: pending } });
            handleSendMessage(pending);
            setPending(null);
        }
    }, [currentBotType, pending]);

    const renderAnswer = () => {
        if (!answer) return null;
        
        const trimmedContent = answer.startsWith('\n') ? answer.substring(1) : answer; // answer 맨 앞의 줄바꿈(\n) 제거

        return (
            <div className={styles.answer}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {trimmedContent}
                </ReactMarkdown>
                {isStreaming && (streamingChatId === chat.chatId) && <div className={styles.readyCursor} />}
            </div>
        );
    };

    const renderData = () => {
        if (isWaitingData && (streamingChatId === chat.chatId) && !data) {
            return (
                <div className={styles.boxLoading}>
                    <Loading />
                </div>
            );
        } 

        if (data && data.table && data.table.length > 0) {
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div className={styles.boxItem}>
                        <ViewButtonBox
                            answerId={answerId}
                            viewType={viewType}
                            updateViewType={updateViewType}
                        />
              
                        {viewType === 'TABLE' &&
                            <div className={styles.boxTable}>
                                <Table
                                    className={styles.ansData}
                                    table={data.table}
                                    dataType={data.dataType}
                                />
                            </div>
                        }
              
                        {viewType === 'CHART' &&
                            <ChartBox
                                data={data.table}
                                dataType={data.dataType}
                            />
                        }
                    </div>

                    {/* <Button
                        size='large'
                        color='primary'
                        variant='outlined'
                        startIcon={<WbTwilightOutlined />}
                        sx={{ alignSelf: 'flex-start' }}
                        onClick={changeBotToAbnormal}
                    >
                        이상탐지
                    </Button> */}
                </Box>
            );
        }

        return null;
    };

    const renderReferenceList = () => {
        if (referenceList && referenceList.length > 0) {
            return (
                <div className={styles.boxReference}>
                    {referenceList.map((reference, index) => (
                        <div 
                            key={index}
                            className={styles.reference}
                            onClick={() => openDocumentViewer(referenceList, index)}
                        >
                            {`출처 ${index + 1} | ${reference.fileName}`}
                            {reference.sheetName && ` > ${reference.sheetName}`}
                            <div className={styles.score}>score : {`${reference.score}`}</div>
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    return (
        <div className={styles.wrapper}>
            {renderAnswer()}
            {renderData()}
            {renderReferenceList()}
        </div>
    );
};

export default AnswerBox;
